export const CTA_ICONS = [
  { value: '', label: 'None' },
  { value: 'fas fa-link', label: 'Link' },
  { value: 'fas fa-envelope', label: 'Email' },
  { value: 'fas fa-calendar-alt', label: 'Calendar' },
  { value: 'fas fa-user-plus', label: 'Follow' },
  { value: 'fas fa-shopping-cart', label: 'Shop' },
  { value: 'fas fa-phone', label: 'Call' },
  { value: 'fas fa-info-circle', label: 'Info' },
  { value: 'fas fa-file-alt', label: 'Document' },
  { value: 'fab fa-github', label: 'GitHub' },
  { value: 'fab fa-linkedin', label: 'LinkedIn' },
  { value: 'fab fa-twitter', label: 'Twitter/X' },
  { value: 'fab fa-youtube', label: 'YouTube' },
];
